import type React from "react";
import { useEffect } from "react";
import { Navigate, Outlet, useSearchParams } from "react-router";
import { useAuthContext } from "../hooks/useAuthContext";

const RouteUnauthorized: React.FC = () => {
  const { user } = useAuthContext();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (user) {
      const redirect = searchParams.get("redirect");
      const destination = redirect ? decodeURIComponent(redirect) : "/";
      if (/^https?:\/\//i.test(destination)) {
        // Only redirect to same origin for security
        try {
          const redirectUrl = new URL(destination);
          const currentUrl = new URL(window.location.href);
          if (redirectUrl.origin === currentUrl.origin) {
            window.location.href = destination;
          }
        } catch {
          // Invalid URL, fall through
        }
      }
    }
  }, [user, searchParams]);

  if (user) {
    const redirect = searchParams.get("redirect");
    const destination = redirect ? decodeURIComponent(redirect) : "/";
    // Only use Navigate for internal paths
    if (!/^https?:\/\//i.test(destination)) {
      return <Navigate to={destination} replace />;
    }
    // For external same-origin redirects, return null while useEffect handles redirect
    return null;
  }

  return <Outlet />;
};

export default RouteUnauthorized;
